// import axios from 'axios';
import {
  createIframe,
  isIOS
  // parseTime
} from '@/common/utils';
import IO from '@/config/api-config';
export default {
  action({
    rqTime,
    useTime,
    callerId = 'XyxzStoreWebApp',
    callerNode = isIOS ? 'ios' : 'no-ios',
    calleeId = 'HjxAppAgent',
    calleeNode,
    methods,
    status
  }) {
    if (!rqTime || !useTime || !calleeId || !calleeNode || !methods || !status)
      return;
    let rqUrl = `${IO.reportURL}?1=${Date.now()
      .toString()
      .substr(0, 10)}=${callerId}=${callerNode.replace(
      /\s/g,
      '+'
    )}=${calleeId}=${calleeNode}=${methods}=${status}=${useTime}`;
    createIframe(rqUrl);
  },
  logs(response) {
    return response;
    // if (process.env.VUE_APP_BUILD_MODE !== 'development') return false;
    // const params = {
    //   req: response.config.data,
    //   res: JSON.stringify(response.data),
    //   time: parseTime(new Date())
    // };
    // axios.post('http://127.0.0.1:7001/logs/insert', params).catch(e => {
    //   console.log('e', e);
    // });
    // axios.post(`${IO.baseUrl}/logs/insert`, params).catch(e => {
    //   console.log('e', e);
    // });
  }
};
